import React, { useRef, useState } from 'react'
import { Modal } from 'bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

function BillingFeatureCTA({ feature, unitName, onClick, children, ...rest }) {
    const [featureEnabled, setFeatureEnabled] = useState(feature && feature.enabled);
    const featureEnabledModalRef = useRef();
    const [billingPortalOpened, setBillingPortalOpened] = useState(false);
    let featureEnabledModal = null;

    const handleCTA = (e) => {
        console.log('featureEnabled :>> ', featureEnabled);
        if (!featureEnabled) {
            if (!featureEnabledModal) {
                featureEnabledModal = new Modal(featureEnabledModalRef.current);
            }
            featureEnabledModal.show();
            e.stopPropagation();
            return;
        }
        onClick();
    }

    const openBillingPortal = () => {
        setBillingPortalOpened(true);
        window.open('/billing-portal', '_blank');
    };

    return (
        <>
            <button onClick={handleCTA} className={`btn ${featureEnabled ? 'btn-primary' : 'btn-outline-dark'}`} {...rest}>
                {children}
            </button>
            {!featureEnabled &&
                <>
                    <div ref={featureEnabledModalRef} className="modal fade">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                {(!feature || (feature?.kind === 'ON_OFF_COMPONENT')) &&
                                    <>
                                        <div className="modal-body text-start">
                                            {!billingPortalOpened &&
                                                <div className='alert alert-warning mb-0'>
                                                    <h5>
                                                        <FontAwesomeIcon icon={faInfoCircle} /> <strong>Plan Limitation:</strong>
                                                    </h5>
                                                    <p>
                                                        This feature is not available with your current subscription plan. Upgrade your plan to unlock this feature.
                                                    </p>
                                                </div>
                                            }
                                            {billingPortalOpened &&
                                                <div className='alert alert-info mb-0'>
                                                    Your plan changes may take a few minutes to take effect. Please refresh this page to see the updates.
                                                </div>
                                            }
                                        </div>
                                        {!billingPortalOpened &&
                                            <div className='modal-footer'>
                                                <button type='button' data-bs-dismiss="modal" className='btn btn-outline-dark'>Not Now</button>
                                                <button type='button' className='btn btn-primary' onClick={openBillingPortal}>Upgrade My Plan</button>
                                            </div>
                                        }
                                    </>
                                }
                                {(feature?.kind === 'PREPAID_USAGE_COMPONENT') &&
                                    <>
                                        <div className="modal-body text-start">
                                            <div className='alert alert-warning mb-0'>
                                                <h5>
                                                    <FontAwesomeIcon icon={faInfoCircle} /> <strong>Payment Required:</strong>
                                                </h5>
                                                <p>
                                                    Purchase a {unitName || 'new one'} for <strong>{feature.unitPrice}</strong>
                                                </p>
                                                Click the <strong>Complete Payment</strong> button below to proceed.
                                            </div>
                                        </div>
                                        <div className='modal-footer'>
                                            <button type='button' data-bs-dismiss="modal" className='btn btn-outline-dark'>Not Now</button>
                                            <button type='button' data-bs-dismiss="modal" className='btn btn-primary' onClick={onClick}>Complete Payment</button>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default BillingFeatureCTA
